import "./Tasks.css";

import { CompleteTaskModal, WorkflowTaskPanel } from "../../../../templates/WorkflowTaskPanel";
import { Button, Column, CursorDataGrid, Row } from "../../../../widget";
import { SelectWorkflowTemplateModal } from "../../components/SelectWorkflowTemplateModal";
import { useTasks } from "./useTasks";

const Tasks = (): JSX.Element => {
  const {
    columns,
    defaultSortingCriteria,
    dataIsLoading,

    showSelectWorkflowTemplateModal,
    setShowSelectWorkflowTemplateModal,

    showWorkflowTaskPanel,
    setShowWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,

    showCompleteTaskModal,
    handleCloseCompleteTaskModal,

    selectedCompleteTask,
    selectedPanelTask,

    workflow,

    isGroupActivity,
    projectTypeUuid,
    projectUuid,

    refreshTasks,
    handleRefresh,

    navigateToTasksBoard,
    onChange,
  } = useTasks();

  return (
    <div className="ProjectTabSection">
      <Row spacingV="m">
        <Column span={6}>
          <h2>Tasks</h2>
        </Column>
        <Column span={6}>
          <div className="ActivityTabSectionTasksButtons">
            {workflow === undefined ? (
              <Button
                text="Apply workflow"
                variant="tertiary"
                fontWeight="light"
                size="small"
                onClick={() => setShowSelectWorkflowTemplateModal(true)}
              />
            ) : (
              !isGroupActivity && (
                <>
                  <Button
                    text="View tasks board"
                    variant="tertiary"
                    fontWeight="light"
                    size="small"
                    onClick={navigateToTasksBoard}
                  />
                  <Button
                    text="New task"
                    fontWeight="light"
                    size="small"
                    onClick={() => setShowWorkflowTaskPanel(true)}
                  />
                </>
              )
            )}
          </div>
        </Column>
      </Row>
      <CursorDataGrid
        columns={columns}
        clientSide={false}
        filterable
        onChange={onChange}
        data={[]}
        refresh={refreshTasks}
        noDataMessage="No tasks to display"
        dataIsLoading={dataIsLoading}
        defaultSortingCriteria={defaultSortingCriteria}
      />
      {projectUuid && projectTypeUuid && (
        <SelectWorkflowTemplateModal
          show={showSelectWorkflowTemplateModal}
          closeModal={() => setShowSelectWorkflowTemplateModal(false)}
          projectUuid={isGroupActivity ? undefined : projectUuid}
          projectTypeUuid={projectTypeUuid}
        />
      )}
      {selectedCompleteTask && (
        <CompleteTaskModal
          task={selectedCompleteTask}
          show={showCompleteTaskModal}
          closeModal={handleCloseCompleteTaskModal}
          closePanel={handleCloseCompleteTaskModal}
          handleRefresh={handleRefresh}
        />
      )}
      <WorkflowTaskPanel
        task={selectedPanelTask}
        currentStepUuid={selectedPanelTask?.step.uuid}
        workflow={workflow}
        show={showWorkflowTaskPanel}
        refresh={refreshTasks}
        handleRefresh={handleRefresh}
        onClose={handleCloseWorkflowTaskPanel}
      />
    </div>
  );
};

export default Tasks;
